document.addEventListener('DOMContentLoaded', function () {

  var CART_ITEM_LIMIT = 2;
  var currentCart = { item_count: 0, items: [] };

  /* ---------------- Search overlay ---------------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchTrigger = document.querySelector('[data-search-trigger]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchDebounce;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
  if (searchOverlay) {
    searchOverlay.querySelectorAll('[data-close-search]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  function renderSearchResults(data, query) {
    if (!searchResults) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (products.length === 0) {
      searchResults.innerHTML = '<p class="search-overlay__empty">Keine Ergebnisse f\u00FCr \u201E' + query + '\u201C.</p>';
      return;
    }

    var html = products.map(function (p) {
      var img = p.featured_image ? p.featured_image.url : (p.image || '');
      return '' +
        '<a href="' + p.url + '" class="search-result-item">' +
          (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '') +
          '<div>' +
            '<p class="search-result-item__title">' + p.title + '</p>' +
            '<p class="search-result-item__price">' + p.price + '</p>' +
          '</div>' +
        '</a>';
    }).join('');

    html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="search-overlay__viewall">Alle Ergebnisse anzeigen</a>';
    searchResults.innerHTML = html;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchDebounce);

      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderSearchResults(data, query); })
          .catch(function () {
            searchResults.innerHTML = '<p class="search-overlay__empty">Suche aktuell nicht verf\u00FCgbar.</p>';
          });
      }, 250);
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTrigger = document.querySelector('[data-cart-trigger]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', function (e) {
    e.preventDefault();
    openCartDrawer();
  });

  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-close-cart]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
  }

  /* ---------------- Cart rendering ---------------- */
  function formatMoney(cents) {
    return '\u20AC ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function renderCart(cart) {
    currentCart = cart;
    var itemsEls = document.querySelectorAll('[data-cart-items]');
    var subtotalEls = document.querySelectorAll('[data-cart-subtotal]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    if (countEls.length) {
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    }

    if (!itemsEls.length) return;

    var html;
    if (cart.item_count === 0) {
      html = '<div class="cart-empty">Dein Warenkorb ist leer.<br><a href="/collections/all" class="btn" style="margin-top:14px;">Weiter shoppen</a></div>';
    } else {
      html = cart.items.map(function (item) {
        return '' +
          '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<img src="' + item.image + '&width=160" alt="' + item.product_title + '" loading="lazy" width="64" height="80">' +
            '<div>' +
              '<p class="cart-line__title">' + item.product_title + '</p>' +
              '<p class="cart-line__variant">' + (item.variant_title || '') + '</p>' +
              '<div class="qty-stepper" data-qty-stepper>' +
                '<button type="button" data-qty-decrease aria-label="Menge verringern">\u2212</button>' +
                '<input type="text" value="' + item.quantity + '" data-qty-input readonly>' +
                '<button type="button" data-qty-increase aria-label="Menge erh\u00F6hen">+</button>' +
              '</div>' +
            '</div>' +
            '<div>' +
              '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
              '<a href="#" class="cart-line__remove" data-remove-line>entfernen</a>' +
            '</div>' +
          '</div>';
      }).join('');
    }

    itemsEls.forEach(function (el) { el.innerHTML = html; });
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }

  function fetchCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('[data-line-key]');
    if (!lineEl) return;
    var key = lineEl.getAttribute('data-line-key');
    var input = lineEl.querySelector('[data-qty-input]');

    if (e.target.matches('[data-qty-increase]')) {
      if (currentCart.item_count + 1 > CART_ITEM_LIMIT) {
        alert('Maximal ' + CART_ITEM_LIMIT + ' Artikel pro Warenkorb.');
        return;
      }
      changeLine(key, parseInt(input.value, 10) + 1);
    }
    if (e.target.matches('[data-qty-decrease]')) {
      var next = parseInt(input.value, 10) - 1;
      changeLine(key, Math.max(0, next));
    }
    if (e.target.matches('[data-remove-line]')) {
      e.preventDefault();
      changeLine(key, 0);
    }
  });

  /* ---------------- Add to cart (AJAX) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var qtyToAdd = parseInt(formData.get('quantity'), 10) || 1;
    var errorEl = form.querySelector('[data-form-error]');

    if (currentCart.item_count + qtyToAdd > CART_ITEM_LIMIT) {
      if (errorEl) errorEl.textContent = 'Maximal ' + CART_ITEM_LIMIT + ' Artikel pro Warenkorb. Du hast bereits ' + currentCart.item_count + ' im Warenkorb.';
      return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (errorEl) errorEl.textContent = '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird hinzugef\u00FCgt \u2026';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        fetchCart();
        openCartDrawer();
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = (err && err.description) || 'Dieser Artikel ist aktuell nicht verf\u00FCgbar.';
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.fullSrc || thumb.src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------------- Quantity stepper (product page) ---------------- */
  document.querySelectorAll('[data-product-qty]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelector('[data-qty-increase]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
    });
    stepper.querySelector('[data-qty-decrease]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
  });

  /* ---------------- Variant swatches ---------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var variantsJson = picker.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);
    var idInput = picker.querySelector('[data-variant-id]');
    var addBtn = document.querySelector('[data-add-to-cart]');
    var priceEl = document.querySelector('[data-product-price]');

    function currentSelection() {
      var selected = [];
      picker.querySelectorAll('[data-option-index]').forEach(function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function updateVariant() {
      var selection = currentSelection();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });

      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Nicht verf\u00FCgbar';
      }
    }

    picker.querySelectorAll('.swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('.swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });

    updateVariant();
  });

  /* ---------------- Discount code ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = input && input.value.trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
  });

  fetchCart();
});
